import http from './api'

const route = 'app/comercial4/'

export default {
  showDadosGraficoBarrasFaturamentoxMetaxMedia: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showDadosGraficoBarrasFaturamentoxMetaxMedia', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showPesoFaturado: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showPesoFaturado', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showPesoFaturadoAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showPesoFaturadoAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showPesoFaturadoAnoAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showPesoFaturadoAnoAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showValorMonetarioPersonalizado: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores) => {
    return http.post(route + 'showValorMonetarioPersonalizado', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showValorMonetarioMetaDiarioPersonalizado: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores) => {
    return http.post(route + 'showValorMonetarioMetaDiarioPersonalizado', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showDadosPedidos: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showDadosPedidos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },
}
